// components
import GridPageAbstract from '../../GridPageAbstract';
import { PersonalcardBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class MerchantEmployeesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'merchantEmployees';
        this.Server = this.props.context.getState().server.merchantEmployees;

        this.headerStartIcon = PersonalcardBulkIcon;

        this.searchFields = [
            'merchant.name',
            'user.firstName',
            'user.lastName',
            'email',
        ];

        this.hiddenColumns = config?.hiddenColumns?.merchantEmployees || [];

        this.Head = [
            {
                id: 'merchantsId',
                sortField: 'merchant.name',
                label: 'merchant',
                object: 'merchant',
                alignRight: false,
                cell: 'Select',
                from: 'merchants',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'merchants'
            },
            {
                id: 'usersId',
                sortField: 'user.firstName',
                label: 'user',
                object: 'user',
                alignRight: false,
                cell: 'Select',
                from: 'users',
                display: 'firstName+lastName'
            },
            { id: 'email', label: 'email', alignRight: false, cell: 'Text' },
            { id: 'phone', label: 'phone', alignRight: false, cell: 'Text' },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
